import type React from 'react';

import { ProofItem } from '#src/app/pages/loginOrSignup/shared/components';
import { useProofCycle } from '#src/app/pages/loginOrSignup/shared/hooks';

const PROOF_STRIP_CYCLE_MS = 3000;
const PROOF_ITEM_COUNT = 3;

/**
 * Mobile-only cycling social proof, shown on the email step below the Continue button.
 *
 * The desktop equivalent is the promo panel's proof card; both are mounted on a treatment email
 * step and hidden by CSS at the other breakpoint, so SSR never flashes the wrong one.
 */
export const ProofStrip: React.FC<EmptyProps> = () => {
	const {
		data: { activeIndex },
	} = useProofCycle({ intervalMs: PROOF_STRIP_CYCLE_MS, itemCount: PROOF_ITEM_COUNT });

	return (
		<div
			data-qa="sap-cycling-proof-strip"
			data-testid="proof-strip"
			className="bg-fill-information-weaker text-typography-information rounded-medium mt-4 flex items-center justify-center px-3 py-2 text-center md:hidden"
		>
			<ProofItem index={activeIndex} iconSize={15} textSize="x-small" />
		</div>
	);
};
